import { CookieHelper } from '../../common/helpers/cookie-helper';
import { BasePortalConfig } from './base-portal-config';
import { PortalType } from './portal-type';

//Config specific to partner center portal
export class PartnerPortalConfig extends BasePortalConfig {
  portalName: string = PortalType.Partner;
  titleKey: string = 'shell.microsoftLogoText';
  aboutSubTitleKey: string = 'settings.modalSubTitle';
  preferencesApplicable = true;
  woboApplicable = true;
  signInPath = '/{locale}/aad?action=signin&returnPath={locale}/dashboard&prompt=select_account';
  pushSurveyId = 'partner.microsoft.com_nps';
  pullSurveyId = 'feedback-survey';
  surveyIntegrationId = 'pc';
  supportPanelIntegrationId = 'pcvnext';
  useFeedbackPanel = false;
  useSupportExtFeatures = true;
  useFDSurveyEndpoint = true;

  constructor() {
    super();
    const isChinaCloud = CookieHelper.getBool('IsChinaCloud');
    if (isChinaCloud) {
      this.titleKey = 'shell.microsoftLogoText_PCBy21Vianet';
      this.portalName = 'china';
    }
    this.setApiEndpoints();
  }

  setApiEndpoints() {
    this.apiEndpoints = {
      auth: '{domain}/{locale}/api/user/AuthContext',
      preference: '{domain}/{locale}/api/user/preferences',
    };
  }
}
